import { render, staticRenderFns } from "./ExamIndex.vue?vue&type=template&id=017223c6&scoped=true"
import script from "./ExamIndex.vue?vue&type=script&lang=js"
export * from "./ExamIndex.vue?vue&type=script&lang=js"
import style0 from "./ExamIndex.vue?vue&type=style&index=0&id=017223c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017223c6",
  null
  
)

export default component.exports